<div class="ui-g ui-g-fluid container">

  <div class="row ui-g-12 no-padding">
    <app-cabecalho-de-impressao
      #appCabecalhoDeImpressao
      [carregarOnLoad]="false"
      [nomeRelatorio]="nomeRelatorio">
    </app-cabecalho-de-impressao>
  </div>

  <!-- FILTROS -->
  <div class="container-filtros row ui-g-12">
    <div class="filtros-label"><!--filtros--></div>
    <div class="filtros">
      <ng-container *ngFor="let filtro of filtros?.getFiltros()">
        <label class="filtro-nome">{{filtro.nome}}:</label>
        <label class="filtro-valor">&nbsp;{{filtro.valorDeExibicao}}</label>
        &nbsp;&nbsp;&nbsp;&nbsp;
      </ng-container>
    </div>
  </div>
  
  <div class="body ui-g-12">
    <app-lista 
      #lista 
      [tipoLista]="'relatorio'" 
      [noServiceAndObservable]="false"
      [exibirLegenda]="false"
      [carregarOnLoad]="false"
      [controller]="controller"></app-lista>
  </div>
</div>